const mixin = {
  filters: {
    eliminarGuionesBajos: function (value) {
      if (!value) return ''
      return value.replace(/_/g, ' ')
    }
  },
  methods: {
    mensajeErrorAxios (error, instanciaVue) {
      let mensaje = ''
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        switch (error.response.status) {
          case 400:
            mensaje += error.response.data['hydra:description'] ? error.response.data['hydra:description'] : error.response.data.message
            break
          case 401:
            mensaje += error.response.data.message
            break
          case 404:
            mensaje += 'URL o recurso no encontrado'
            break
          case 403:
            mensaje += 'Acceso restringido'
            break
          default:
            mensaje += 'Servidor respondió solicitud inválida'
            break
        }
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        mensaje += error.message
      } else {
        // Something happened in setting up the request that triggered an Error
        mensaje += 'Error desconocido'
      }

      this.$buefy.dialog.alert({
        title: 'Error',
        message: `<p>${mensaje.replace(/\n/g, '</p><p>')}</p>`,
        type: 'is-danger',
        hasIcon: true
      })
    },
    formatFecha (fecha) {
      if (fecha !== null) {
        const fechaDate = new Date(fecha)
        return fechaDate.toLocaleDateString('es-AR', { year: 'numeric', month: '2-digit', day: '2-digit' })
      }
      return null
    },
    truncate (cadena, corteTruncate) {
      if (cadena.length <= corteTruncate) {
        return cadena
      } else {
        return cadena.substring(0, corteTruncate)
      }
    },
    handleUnexpectedError (err) {
      // TODO: Enviar error a algun lugar
      if (err) {}
    }
  }
}

export default mixin
